<nz-select
  [name]="config.name"
  [nzShowSearch]="config.showSearch"
  [nzAllowClear]="config.allowClear"
  [nzPlaceHolder]="config.placeholder"
  [(ngModel)]="config.value"
  (ngModelChange)="onChange($event)"
  [required]="config.required"
>
  <ng-container *ngFor="let item of config.dataSource">
    <nz-option [nzLabel]="item.label" [nzValue]="item.value"></nz-option>
  </ng-container>
</nz-select>
